import { useModuleDefinition } from '@platform/modularity/useModuleDefinition';
import { ErrorBanner, Spinner } from '@platform/ui';
import { useWorkspaceParams } from '@platform/hooks/useWorkspaceParams';
import { RecordListBody } from './RecordListBody';

/**
 * Сторінка таблиці модуля: бере визначення модуля (сервер — злите з налаштуваннями простору, ADR-023; або пакет), обирає тип запису (з маршруту
 * або головний) і рендерить тіло списку. Приховані поля (`hidden`) лишаються в типі — за ними рахує швидкий фільтр, — але їх не показують
 * стовпці, фільтри й вибори полів.
 */
export function RecordListPage() {
  const { ws, module: moduleKey, rt: rtKey, view } = useWorkspaceParams();
  const { data: module, isLoading, error } = useModuleDefinition(moduleKey);
  const rt = module?.recordTypes.find((r) => r.key === rtKey) ?? module?.recordTypes.find((r) => r.main);
  if (isLoading) return <Spinner />;
  if (error || !module || !rt) return <ErrorBanner error={error ?? { message: 'Module not found' }} />;
  return <RecordListBody ws={ws} module={module} rt={rt} routeView={view} />;
}
